<template>
  <div>
    <main-layout>
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <template v-if="$store.state.privilege && $store.state.privilege.role === 'superadmin'">
          <v-tab href="#branch-management" ripple>{{ $t('branch_management') }}</v-tab>
          <v-tab href="#permission-dashboard" ripple>{{ $t('permission') }}</v-tab>
          <v-tab href="#admin-management" ripple>{{ $t('admin_management') }}</v-tab>
          <v-tab href="#engineer-list" ripple>{{ $t('engineer_list') }}</v-tab>
        </template>
        <v-tab href="#connect-line-approver" ripple>{{ $t('connect_approver') }}</v-tab>
      </v-tabs>
      <div v-if="currentView === 'branch-management'">
        <BranchManagement></BranchManagement>
      </div>
      <div v-else-if="currentView === 'permission-dashboard'">
        <Permission></Permission>
      </div>
      <div v-else-if="currentView === 'admin-management'">
        <AdminManagement></AdminManagement>
      </div>
      <div v-else-if="currentView === 'engineer-list'">
        <EngineerList></EngineerList>
      </div>
      <div v-else-if="currentView === 'connect-line-approver'">
        <ConnectLineApprover></ConnectLineApprover>
      </div>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BranchManagement from './BranchManagement.vue'
import Permission from './Permission.vue'
import AdminManagement from './AdminManagement.vue'
import EngineerList from './EngineerList.vue'
import ConnectLineApprover from './ConnectLineApprover.vue'

export default {
  data() {
    return {
      currentView: 'permission'
    }
  },
  components: {
    BranchManagement,
    Permission,
    AdminManagement,
    EngineerList,
    ConnectLineApprover
  },
  created() {
    const vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'branch-management':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'branch-management'
          break
      }
    } else {
      if (
        ['approver', 'supervisor'].includes(
          this.$store.state.privilege && this.$store.state.privilege.role
        )
      ) {
        vm.currentView = 'connect-line-approver'
      }

      if (this.$store.state.privilege && this.$store.state.privilege.role === 'superadmin') {
        vm.currentView = 'branch-management'
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'YasaleAcAdminMenu',
        path: '/yasale-ac-admin-menu',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/AdminMenu.vue